<template>
  <div style="display: flex; flex-direction: column; justify-content: flex-start;height: 100%;">
    <div class="findbox">
      <div class="fb_tj" :style="{maxHeight:show_search?'500px':'0',opacity:show_search?1:0}">
        <div style="display: flex; align-items: center; margin-bottom: 10px">
          <el-page-header @back="goBack"></el-page-header>
          <!-- 搜索筛选 -->
          <div style="display: flex; align-items: center">
            <el-input @keyup.enter.native="search" size="small" v-model="filter.keyword" placeholder="ID/用户昵称/手机号" style="width: 200px; margin-right: 10px"></el-input>
<!--            <el-cascader-->
<!--              placeholder="请选择经营类目"-->
<!--              filterable-->
<!--              style="width: 240px"-->
<!--              :props="cateProps"-->
<!--              :options="categoriesData"-->
<!--              @change="search"-->
<!--              size="small"-->
<!--              v-model="filter.category"-->
<!--            />-->
            <el-button size="small" type="primary" @click="search" style="margin-left: 10px">查询</el-button>
            <el-button size="small" @click="reflush">重置</el-button>
          </div>
        </div>

        <div class="cate-c">

            <div class="label">
              <span class="label-name">主营类目：</span>
              <span  class="all-but" @click="selAll">全部</span>
            </div>

          <div class="cate-container">
            <div class="cate-items" >
              <div>
                <div>

                </div>
              </div>
              <div class="cate-item" v-for="(item,index) in categoriesData" :class="{active:item.id==(filter.category[0]?filter.category[0]:null) }" @click="selectcate($event,item,index,1)" :key="'a'+index">{{item.name}}</div>
            </div>
            <div v-if="cateList2.length>0" class="cate-items" >
              <div class="cate-item" v-for="(item,index) in cateList2" :class="{active:item.id==(filter.category[1]?filter.category[1]:null)  }" @click="selectcate($event,item,index,2)" :key="'b'+index">{{item.name}}</div>
            </div>
<!--            <div v-if="cateList3.length>0"  class="cate-items" >-->
<!--              <div class="cate-item" v-for="(item,index) in cateList3" :class="{active:item.id==(filter.category[2]?filter.category[2]:null)  }" @click="selectcate($event,item,index,3)" :key="'c'+index">{{item.name}}</div>-->
<!--            </div>-->
          </div>

        </div>
      </div>
      <div v-if="show_search" @click="show_search =!show_search" class="s_a_h"><i class="el-icon-arrow-up"></i>收起</div>
      <div v-else @click="show_search =!show_search" class="s_a_h"><i class="el-icon-arrow-down"></i>展开</div>
    </div>
    <!--列表-->
    <div style="flex-grow: 1;margin-bottom: 10px;width: 100%;position: relative;overflow-y: auto;">
      <div v-if="datalist.list&&datalist.list.length>0" style="display: flex;flex-wrap: wrap;">
        <div v-for="(item,index) in datalist.list" class="once" >
          <div class="once_title">{{item.shop.name}}</div>


          <div class="company-info">
            <div class="info-item">
              <el-tooltip :content="item.shop.desc" placement="top-start" effect="light">
                <div>公司简介：{{item.shop.desc}}</div></el-tooltip>
            </div>
            <div  class="info-item">

                <div>联系人：{{item.shop.operate_name}} </div>

              </div>
            <div  class="info-item">
              <el-tooltip :content="setCateText(item.shop.category)" placement="top-start" effect="light">
                <div>主营类目：{{setCateText(item.shop.category)}}</div>
              </el-tooltip>
               </div>
            <div  class="info-item">
                <div>联系电话：{{item.shop.mobile}}</div>
              </div>
            <div  class="info-item">
                <div>公司地址：{{item.shop.province}}{{item.shop.city}}</div>
               </div>
            <div  class="info-item">
                <div>电子邮箱：{{item.shop.operate_email}} </div>
              </div>
          </div>
          <div class="once_spu">
            <div @click="gogoodsInfo(inner)" v-for="(inner,i) in item.three_goods" :key="index+'i'+i+'d'+inner.product_id" :style="{backgroundImage:`url(${inner.goods_image_url[0]})`}" class="div">
              <span>供货价￥{{inner.price}}</span>
            </div>
          </div>
          <div class="once_btn">
            <template v-if="item.is_applied" >
              <div class="btn1"  disabled size="small" v-if="item.supplier_status==0">审批中</div>
              <div class="btn2" disabled size="small" v-if="item.supplier_status==1">已合作</div>
              <div class="btn3" disabled size="small" v-if="item.supplier_status==2">已拒绝</div>
              <div class="btn4" disabled size="small" v-if="item.supplier_status==3">禁用</div>
            </template>
            <div v-else :disabled="shop_id == item.shop.shop_id" class="btn5" @click="tosupplierApply(item.shop.shop_id)"  size="small">申请</div>
            <div class="btn6" type="primary" plain @click="goSupplierGoods(item.shop.shop_id,item.shop.name)" size="small">查看商品</div>
          </div>
        </div>
      </div>
      <div v-else style="height: 100%;display: flex;align-items: center;justify-content: center;">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>
    <!-- 分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="filter.page"
      :page-sizes="pageSizes"
      :page-size="filter.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="datalist.count"
    ></el-pagination>
    <el-dialog class="msgDialog" title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="msg_title">
        <i class="el-icon-warning"></i>
        <span>{{ msg }}</span>
      </div>
      <el-image class="msg_img" :src="require('../../../static/msg_image.jpg')" :preview-src-list="[require('../../../static/msg_image.jpg')]" fit="cover"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="goshopInfo" size="small">去修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_search:true,
      p_loading: false,
      pageSizes: [20, 50, 100],
      shop_id: '',
      filter: {
        keyword: '',
        category: [],
        page: 1,
        limit: 20
      },
      datalist: {},
      categoriesData: [],
      cateList2:[],
      cateList3:[],
      cateProps: {
        label: 'name',
        value: 'id',
        children: 'childLevel'
      },
      dialogVisible: false,
      msg: ''
    };
  },
  created() {
    this.shop_id = this.$store.state.shop_data.shop_id;
    this.getCategories();
  },
  methods: {
    selAll(){
      this.filter.category=[];
      this.getList()
    },
    selectcate(e,item,index,level=1){
      if(this.filter.category.length>level){
        this.filter.category=this.filter.category.splice(0,level)
      }
      switch (level){
        case 1:
          if(item.childLevel&&item.childLevel.length>0){
            this.cateList2=item.childLevel;
          }else{
            this.cateList2=[];
          }
          this.cateList3=[];
          break;
        // case 2:
        //   if(item.childLevel&&item.childLevel.length>0){
        //     this.cateList3=item.childLevel;
        //   }else{
        //     this.cateList3=[];
        //   }
        //   break;

      }
      this.filter.category[level-1]=item.id
      this.getList()
    },
    goshopInfo() {
      this.$router.push({
        path: '/shopInfo'
      });
      this.dialogVisible = false;
    },
    setCateText(data) {
      let rText = '';
      data = JSON.parse(data);
      if (data) {
        data = data.map((item) => {
          return parseInt(item);
        });
        this.categoriesData.forEach((item) => {
          if (item.id == data[0]) {
            rText = rText + item.name;
            item.childLevel.forEach((inner) => {
              if (inner.id == data[1]) {
                rText = rText + '/' + inner.name;
                inner.childLevel.forEach((i) => {
                  if (i.id == data[2]) {
                    rText = rText + '/' + i.name;
                  }
                });
              }
            });
          }
        });
      } else {
        rText = '暂无';
      }
      return rText;
    },
    goSupplierGoods(shop_id,shop_name) {
      this.$router.push({
        path: '/supplierGoods',
        query: {
          shop_id: shop_id,
          status: 0,
          shop_name:shop_name
        }
      });
    },
    // 申请与供应商合作
    tosupplierApply(shop_id) {
      this.$confirm('是否确认申请与该供应商合作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$post(this.$api.supplierApply, { supplier_shop_id: shop_id }).then((res) => {
          if (res.status == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.getList();
          } else if (res.status == 10086) {
            this.msg = res.msg;
            this.dialogVisible = true;
          }
        });
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    gogoodsInfo(item) {
      // this.$router.push({
      //   path: '/supplierInfoNo',
      //   query: {
      //     sku_id: item.product_id
      //   }
      // });
      localStorage.setItem('c_shopId', item.shop_id);
      this.$router.push({
        path: '/supplierInfo',
        query: {
          sku_id: item.product_id,
          type:'spu',
          shop_id:item.shop_id
        }
      });
    },
    getList() {
      this.p_loading = true;
      // category簌桢弱{注嬴臧
      this.$get(this.$api.supplierList, this.filter).then((res) => {
        if (res.status == 200) {
          this.datalist = res.data;
          this.p_loading = false;
        }
      });
    },
    getCategories() {
      this.p_loading = true;
      this.$get(this.$api.getCategories).then((res) => {
        if (res.status == 200) {
          this.categoriesData = res.data;
          this.getList();
        }
      });
    },
    handleSizeChange(val) {
      this.filter.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getList();
    },
    // 搜索事件
    search() {
      this.filter.page = 1;
      this.getList();
    },
    reflush() {
      this.filter.keyword = '';
      this.filter.category = [];
      this.getList();
    }
  }
};
</script>

<style scoped>
/deep/ .msgDialog .el-dialog__body {
  padding: 10px 20px;
}
.msg_title {
  display: flex;
}
.msg_title i {
  color: #e6a23c;
  font-size: 24px;
  margin-right: 10px;
}
.msg_title span {
  font-size: 14px;
  line-height: 24px;
}
.msg_img {
  width: 100%;
}
.findbox{
  display: flex;
}
.fb_tj{
    flex: 1;
    overflow: hidden;
    transition: all 1s;
  }
.s_a_h{
  font-size: 12px;
  color: #409eff;
  padding-bottom: 10px;
  cursor: pointer;
}
.s_a_h i{
  font-weight: bold;
  margin-right: 4px;
}
.once{
  box-sizing: border-box;
  width: 32.8%;
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  margin-right: 0.8%;
  margin-bottom: 0.8%;
  padding: 10px;
}
.once:hover{
  border-color: #409EFF;
  cursor: pointer;
}
.once:nth-child(3n){
  margin-right: 0;
}
.once_title{
  font-size: 18px;
  margin-bottom: 10px;
}
.once_tag{
  display: flex;
  align-items: center;
}
.once_tag span{
  font-size: 12px;
  color: darkorange;
  border: 1px solid darkorange;
  padding: 2px 4px;
  margin-right: 6px;
  border-radius: 2px;
}
.once_platform{
  color: gray;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 10px;
}
.once_platform_img{
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 6px;
}
.once_cate{
  margin-top: 10px;
  font-size: 12px;
  color: gray;
}
.once_spu{
  display: flex;
  align-items: center;
  margin: 15px 0;
}
.once_spu .div{
  position: relative;
  width: 32%;
  padding-bottom: 32%;
  margin-right: 2%;
  border-radius: 8px;
  background: url('') no-repeat center center/100% 100%;
  background-size: cover;
  overflow: hidden;
}
.once_spu .div:nth-child(3n){
  margin-right: 0;
}
.once_spu .div span{
  font-size: 14px;
  line-height: 30px;
  width: 100%;
  text-align: center;
  color: white;
  background: rgba(0, 0, 0, .5);
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 2px 0;
  overflow: hidden; /* 超出的文本隐藏 */
  text-overflow: ellipsis; /* 溢出用省略号显示 */
  white-space: nowrap; /* 溢出不换行 */
}
.once_btn{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap:10px;
}
.btn1,.btn2,.btn3,.btn4,.btn5,.btn6{
  text-align: center;
  width: 50%;
  line-height: 36px;
  border-radius: 3px;
  color: #FFFFFF;
}
.once_btn div:hover{
  opacity: 0.85;
}
.btn1{
  border: 1px solid #909399;
  background-color: #909399;
}
.btn2{
  border: 1px solid #67c23a;
  background-color: #67c23a;
}
.btn3{
  border: 1px solid #909399;
  background-color: #f56c6c;
}
.btn4{
  border: 1px solid #e6a23c;
  background-color: #e6a23c;
}
.btn5{
  border: 1px solid #3a8ee6;
  background-color: #3a8ee6;
}
.btn6{
  border: 1px solid #3a8ee6;
  border: 1px solid #3a8ee6;
  color: #3a8ee6;
}
.cate-c{
  display: flex;
  font-size: 12px !important;
  font-weight: 400;
  gap: 10px;
  margin: 20px 0;
  width: 100%;
  color: gray;
}
.cate-c .label{
  font-size: 14px !important;
  flex: 0 0 auto;
}

.cate-c .label .all-but{
  background-color: #3a8ee6;
  padding: 5px 10px;
cursor: pointer;
  color: #FFFFFF;
  border-radius: 4px;

}
.cate-container {
  display: flex;
  flex:  1 1 auto;
  flex-direction: column;
}
.cate-container  .cate-items{
  flex:  1 1 auto;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.cate-container  .cate-items:nth-child(2){

}
.cate-container  .cate-item{
  padding: 0px 10px ;
  line-height: 24px;

  cursor: pointer;
  flex: 0 0 auto;
  display: inline-block;
  margin-right: 5px;
  border-radius: 4px;
}
.cate-container  .cate-item:hover{
  color: #3a8ee6;


}
.cate-container  .cate-item.active{
  background-color: #3a8ee6;
  color: #FFFFFF;
}
.company-info{
  font-size: 14px;
  color: gray;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  line-height: 24px;

}
.company-info  .info-item{
  width: calc(50% - 10px);
  flex: 0 0 auto;
}
.company-info  .info-item div{
  overflow: hidden; /* 超出的文本隐藏 */
  text-overflow: ellipsis; /* 溢出用省略号显示 */
  white-space: nowrap; /* 溢出不换行 */

}
</style>



// WEBPACK FOOTER //
// src/views/supplier/add.vue